<script setup lang="ts">
import { RouterLink } from 'vue-router'

defineProps<{
  plate: string
  clickable?: boolean
}>()
</script>

<template>
  <RouterLink
    v-if="clickable"
    :to="{ name: 'pursuit-plate', params: { plate } }"
    class="plate-chip plate-link mono"
  >
    {{ plate }}
  </RouterLink>
  <span v-else class="plate-chip mono">{{ plate }}</span>
</template>

<style scoped>
.plate-chip {
  display: inline-block;
  padding: 2px 8px;
  border-radius: var(--r-chip);
  background: var(--accent-soft);
  color: var(--accent-2);
  font-size: var(--fs-13);
  font-weight: 600;
  letter-spacing: 0.04em;
  white-space: nowrap;
  text-decoration: none;
}
.plate-link {
  cursor: pointer;
  transition: background 120ms;
}
.plate-link:hover { background: var(--accent-soft-2); }
</style>
